module.exports = __webpack_public_path__ + "7bd272bfc3a705674329858b36e33c35.mp3";